import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { change } from "redux-form";
import { format } from "date-fns";

import { makeStyles } from "@material-ui/styles";

import InfoIcon from "@material-ui/icons/Info";

import { List, FilterButton, Filter, FunctionField, TextField, SelectInput } from "jazasoft";

import Datagrid from "../../components/Datagrid";
import TooltipTextField from "../../components/TooltipTextField";
import { inputOptions, isEmpty } from "../../utils/helpers";
import { usePrevious, useQuery, useSafeState } from "../../hooks";
import ActivityDetailsDrawer from "./details/ActivityDetailsDrawer";

const choicesStatus = ["Success", "Failure"].map(e => ({ id: e, name: e }));
// const choicesOperation = ["write", "update", "delete"].map(e => ({ id: e, name: e }));

const ViewButton = props => {
  const { record, onInfoClick } = props;
  return (
    <div style={{ padding: "0.25rem" }} onClick={() => onInfoClick(record)}>
      <InfoIcon />
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  content: {
    margin: "1.5em"
  }
}));

const SystemActivityHome = props => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [drawerState, setDrawerState] = useSafeState({ open: false, userActivity: null });

  const filterValues = useSelector(state => state.form && state.form["filter-form"]?.values);

  const entityName = filterValues?.entityName;
  const prevEntityName = usePrevious(entityName);

  const { data: users = [] } = useQuery({ url: `system-activities/user` });
  const { data: entityNames = [] } = useQuery({ url: `system-activities/entity-name` });
  const { data: events = [] } = useQuery(!isEmpty(entityName) && { url: `system-activities/event`, params: { entityName } });
  const { data: urlList = [] } = useQuery(!isEmpty(entityName) && { url: `system-activities/url`, params: { entityName } });

  const onInfoClick = record => {
    setDrawerState({ open: true, userActivity: record });
  };

  React.useEffect(() => {
    if (entityName !== prevEntityName) {
      dispatch(change("filter-form", "event", null));
    }
  }, [entityName, prevEntityName, dispatch]);

  const choicesEntity = entityNames.map(e => ({ id: e, name: e }));
  const choicesEvent = events.map(e => ({ id: e, name: e }));
  const choicesUrl = urlList.map(e => ({ id: e, name: e }));
  const choicesUser = users.map(e => ({ id: e, name: e.includes(",") ? e.substring(0, e.lastIndexOf(",")) : e }));

  return (
    <div>
      <ActivityDetailsDrawer
        open={drawerState?.open || false}
        userActivity={drawerState?.userActivity}
        onDrawerClose={() => setDrawerState({ open: false, userActivity: null })}
      />

      <List
        searchKeys={["searchText", "reqParams", "reqBody", "resBody", "currValue", "prevValue"]}
        actions={({ resource }) => (
          <div>
            <FilterButton showLabel={false} resource={resource} />
          </div>
        )}
        filters={
          <Filter>
            <SelectInput source="status" i18nKey={props.i18nKey} choices={choicesStatus} {...inputOptions(12)} />
            <SelectInput source="entityName" i18nKey={props.i18nKey} choices={choicesEntity} {...inputOptions(12)} />
            <SelectInput source="event" i18nKey={props.i18nKey} choices={choicesEvent} {...inputOptions(12)} />
            <SelectInput source="url" i18nKey={props.i18nKey} choices={choicesUrl} {...inputOptions(12)} />
            <SelectInput source="createdBy" i18nKey={props.i18nKey} choices={choicesUser} {...inputOptions(12)} />
          </Filter>
        }
        filterDefaultValues={{ type: "USER" }}
        {...props}>
        <Datagrid classes={{ headerCell: classes.headerCell, rowCell: classes.rowCell }}>
          <TextField source="id" />
          <TextField source="entityName" />
          <TextField source="event" />
          <TextField source="operation" />
          <TextField source="searchText" />
          <TooltipTextField source="url" />
          <FunctionField source="createdAt" render={record => format(record.createdAt, "MMM dd yyyy, HH:mm a")} />
          <FunctionField source="createdBy" render={record => record.createdBy} />
          <FunctionField source="status" render={record => record.status} />
          <ViewButton onInfoClick={onInfoClick} />
        </Datagrid>
      </List>
    </div>
  );
};

export default SystemActivityHome;
